import * as React from 'react';
import { Select } from 'antd';

interface FilterDropdownProps {
  placeholder: string;
  loading: boolean;
  onChange: (value: string) => void;
  value: string | undefined;
  options: Array<{ label: string; value: string | number }>;
  width?: number;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  placeholder,
  loading,
  onChange,
  value,
  options,
  width = 200,
}) => (
  <div style={{ padding: 8 }}>
    <Select
      showSearch
      optionFilterProp='label'
      placeholder={placeholder}
      style={{ width }}
      loading={loading}
      onChange={onChange}
      value={value}
      options={options}
      allowClear
    />
  </div>
);

export default FilterDropdown;
